module.exports = __webpack_public_path__ + "static/img/products application_pu4.43fd32e7.jpg";